const WEB = 'WEB';
const APP = 'APP';
const WINDOWS = 'WINDOWS'; // windows客户端
const getPlatform = () => {
    if (window.app) {
        return APP;
    }
    if (window.ClientType === 'Windows') {
        return WINDOWS;
    }
    return WEB;
};
const isMobile = () => {
    if (/ipad|iphone|ipod|android/.test(navigator.userAgent.toLowerCase()) || getPlatform() === APP) {
        return true;
    }
    return false;
};
const isWindows = () => (
    getPlatform() === WINDOWS
);

export {
    isMobile,
    isWindows,
    getPlatform
};
